import type { IMasterDataPromoTypesLookupRepository } from "@src/domain/repositories/masterData";
import type { PromoTypeLookupItem } from "@src/domain/dto/masterData";

export class GetPromoTypesLookupUseCase {
  private readonly repository: IMasterDataPromoTypesLookupRepository;

  constructor(repository: IMasterDataPromoTypesLookupRepository) {
    this.repository = repository;
  }

  execute(): Promise<{ items: PromoTypeLookupItem[]; count: number }> {
    return this.repository.getPromoTypesLookup();
  }
}
